// 是否是测试环境
export const isTestEnv = () => {
	return /uat|stg|dev/.test(window.location.host)
}
